import { paths } from 'src/routes/paths';

import { Icons } from './config';

export const navDataClient = [
  {
    subheader: '',
    items: [
      { title: 'Trang tổng quan', path: paths.client.root, icon: Icons.dashboard },
      { title: 'Tiến độ học tập', path: paths.client.learningprogress, icon: Icons.course },
      { title: 'Trò chuyện', path: paths.client.chat, icon: Icons.chat },
      { title: 'Thông báo', path: paths.client.notify, icon: Icons.notify },
      { title: 'Lịch', path: paths.client.calendar.testSchedule.root, icon: Icons.calendar },
      { title: 'Chứng chỉ', path: paths.client.certificate, icon: Icons.certificate },
      // { title: 'Lịch', path: paths.client.calendar.schedule.root, icon: Icons.calendar },
      // {
      //   title: 'Khóa học đóng góp',
      //   path: paths.client.contribution.root,
      //   icon: Icons.contribution,
      //   children: [
      //     {
      //       title: 'Danh sách',
      //       path: paths.client.contribution.root,
      //     },
      //     {
      //       title: 'Thêm mới',
      //       path: paths.client.contribution.create,
      //     },
      //   ],
      // },
      // { title: 'Khóa học yêu thích', path: paths.client.wishlist, icon: Icons.wishList },
      // { title: 'Mentoring 1:1', path: paths.client.mentoring, icon: Icons.calendar },
      // {
      //   title: 'Lịch',
      //   path: paths.client.calendar.root,
      //   icon: Icons.calendar,
      //   children: [
      //     {
      //       title: 'Lịch học',
      //       path: paths.client.calendar.schedule.root,
      //     },
      //     {
      //       title: 'Lịch họp',
      //       path: paths.client.calendar.meetingSchedule.root,
      //     },
      //     {
      //       title: 'Lịch thi',
      //       path: paths.client.calendar.testSchedule.root,
      //     },
      //   ],
      // },
    ],
  },
];
